import billingStatuses from '../../const/billingStatuses';

function billingStatusHelper(status, memberOf) {
    let caseName = '', message = '';

    const isOrganizationMember = !!memberOf;
    const addMoneyMsg = isOrganizationMember ?
        `Please contact the organization's administrator to add funds to the organization's account.` :
        'Please add funds to your account or use a promo code.';

    switch (status) {
        case billingStatuses.RUNNING_LOW:
            caseName = 'warning';
            message = `You are running low on interactions. ${addMoneyMsg}`;
            break;
        case billingStatuses.LIMITED:
            caseName = 'error';
            message = `You are out of interactions. ${addMoneyMsg}`;
            break;
        case billingStatuses.BLOCKED:
            caseName = 'error';
            message = `You are out of interactions. User commands are unavailable on all of your projects. ${addMoneyMsg}`;
            break;
        default:
            break;
    }

    return { caseName, message };
}

export default billingStatusHelper;
